// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-popover-docs',
    templateUrl: './popover.docs.generated.html',
})
export class UIPopoverDocs { }
